const timelineData = [
  {
    year: 2015,
    mounth: '',
    descriptions: ['Nasce a Resale'],
  },
  {
    year: 2016,
    mounth: '',
    descriptions: [
      'Assinamos contrato com o primeiro grande banco, o Santander.',
    ],
  },
  {
    year: null,
    mounth: '',
    descriptions: [
      'Realizamos a primeira venda de um imóvel pela plataforma, 100% à distância.',
    ],
  },
  {
    year: 2017,
    mounth: '',
    descriptions: ['Lançamento da 1ª versão do nosso aplicativo.'],
  },
  {
    year: null,
    mounth: '',
    descriptions: [
      'Lançamento da nossa plataforma Repex® um serviços de SaaS (Software as a Service) para os bancos (B2B).',
    ],
  },
  {
    year: null,
    mounth: '',
    descriptions: [
      ' Fomos escolhidos como uma das 20 startups mais inovadoras do Brasil pelo Programa Empreenda Santander.',
    ],
  },
  {
    year: 2018,
    mounth: '',
    descriptions: [
      'Mudamos para nossa sede atual em Piracicaba, deixando para trás a sala de 25m² onde começamos.',
    ],
  },
  {
    year: null,
    mounth: '',
    descriptions: [
      'Inauguramos nosso escritório de tecnologia em Belo Horizonte/MG.',
    ],
  },
  {
    year: null,
    mounth: '',
    descriptions: [
      'Atingimos a marca de 1.500 imóveis vendidos por meio das nossas plataformas.',
    ],
  },
  {
    year: 2019,
    mounth: '',
    descriptions: [
      'Somos selecionados para participar do Programa BoostLab do Banco BTG Pactual.',
    ],
  },
  {
    year: null,
    mounth: '',
    descriptions: ['Mais de 2.000 imóveis vendidos pelas nossas plataformas.'],
  },
  {
    year: null,
    mounth: '',
    descriptions: [
      'Lançamento da nova marca, trazendo a ideia de ciclo e remetendo ao retorno dos imóveis ao mercado.',
    ],
  },
  {
    year: null,
    mounth: '',
    descriptions: [
      'O BTG Pactual, maior Banco de Investimentos da América Latina, anuncia a entrada como sócio da empresa.',
    ],
  },
  {
    year: null,
    mounth: '',
    descriptions: [
      'Lançamento do novo site e o nascimento da Rosie, nossa assistente inteligente para busca de imóveis.',
    ],
  },
]

export default timelineData
